/**
 * Shared control styling for settings rows so native inputs/selects match the
 * design's 36px, 8px-radius fields in both themes.
 */
export const settingsInputClass =
  'flex h-9 w-full rounded-lg border border-input bg-card px-3 text-base shadow-xs transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60 md:text-sm'

export const settingsSelectClass = `${settingsInputClass} appearance-auto pr-2`
